module.exports = __webpack_public_path__ + "static/media/playstore.582a7533.svg";